module.exports = __webpack_public_path__ + "static/img/5.e1024c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/5.jpg
// module id = GFPr
// module chunks = 2